import InheritParameters from './query-parameters/InheritParameters.js';
import SpatialQueryParameters from './query-parameters/SpatialQueryParameters.js';
const patterns = {
    inherit: InheritParameters,
    spatialQuery: SpatialQueryParameters,
    byPatternType: {
        [InheritParameters.PATTERN_TYPE]: InheritParameters,
        [SpatialQueryParameters.PATTERN_TYPE]: SpatialQueryParameters,
    },
};
export default patterns;
